<app-header></app-header>
<app-side-nav></app-side-nav>

@let userResultsLoaded = results.isLoadedState();

@if (userResultsLoaded) {
  <div class="promo-bg pt-50 pb-40" [ngStyle]="{opacity: userResultsLoaded ? '1' : '0'}">
      <h3 class="uppercase my-40 text-32 font-weight-700 text-center sm:mt-10 sm:mb-0 sm:text-20">{{'t.user-result' | translate}}</h3>
<!--      <app-tabs class="results-tabs">-->
<!--        <app-tab-item [tabTitle]="'t.previous-month' | translate">-->
<!--          <ng-container *ngTemplateOutlet="userResults"></ng-container>-->
<!--        </app-tab-item>-->
<!--        <app-tab-item [tabTitle]="'t.this-month' | translate">-->
<!--          <ng-container *ngTemplateOutlet="userResults"></ng-container>-->
<!--        </app-tab-item>-->
<!--        <app-tab-item [tabTitle]="'t.all-time-results' | translate">-->
<!--          <ng-container *ngTemplateOutlet="userResults"></ng-container>-->
<!--        </app-tab-item>-->
<!--      </app-tabs>-->

      <ng-container *ngTemplateOutlet="userResults"></ng-container>

      <ng-template #userResults>
        <div class="container">
          <div class="flex line flex-col items-center text-center mb-20 mt-60 p-20 sm:mb-70">
            <img class="main-img mt--40 mb-10" src="/assets/img/user-results/page/biggest_win.png" alt="">
            <div class="text-24 font-weight-800 uppercase md:text-16 sm:mb-20 sm:pt-10">
              {{ 't.my-biggest-win' | translate }}
            </div>
            @if (results.userBiggestWinGame()) {
              <div class="bold-title text-focus">
                {{ results.userBiggestWin() || 0 }}
              </div>
              <div class="text-36 text-focus mb-16 font-weight-800 md:text-24">
                {{ user.currentCurrency?.currency }}
              </div>
              <div class="w-100 flex justify-center">
                <div class="font-weight-600 flex justify-center items-end px-20 py-10 sm:mt-10">
                  <img class="game-img-header mr-10" [src]="results.userBiggestWinGame()?.image" alt="">
                  <div>
                    <div class="text-focus mb-8 text-12">{{ results.userBiggestWinGame()?.title }}</div>
                    <div class="mb-8 text-12 text-left uppercase">{{ results.userBiggestWinGame()?.provider === 'softswiss' ? '' : results.userBiggestWinGame()?.provider }}</div>
                  </div>
                </div>
              </div>
            } @else {
              <div class="text-64 sm:text-32 font-weight-700 w-50 sm:w-75 mt-50 sm:mt-20 mb-70 sm:mb-40">{{ 't.start-win-now' | translate }}</div>
              <button class="btn big btn--filled-primary" routerLink="/games">{{ 'btn.play' | translate }}</button>
            }
          </div>
          <div class="flex flex-col">
            <div class="grid-wins mb-40 sm:mb-20 sm:order-1">
              <div class="result-card p-20 flex flex-col items-center justify-between">
                <div class="flex flex-col items-center">
                  <img width="70" src="/assets/img/user-results/page/last-win.png" alt="">
                  <div class="text-focus text-24 font-weight-800 md:text-16 sm:mt-20">
                    {{ results.userLastWin() || 0 }} {{ user.currentCurrency?.currency }}
                  </div>
                </div>
                <div class="text-14 mt-20 md:text-10 sm:mt-20">{{ 't.my-last-win' | translate }}</div>
              </div>
              <div class="result-card p-20 flex flex-col items-center justify-between">
                <div class="flex flex-col items-center">
                  <img width="70" src="/assets/img/user-results/page/winnings.png" alt="">
                  <div class="text-focus text-24 font-weight-800 md:text-16 sm:mt-20">{{ results.sumOfAllWinsOfUser() || 0 }} {{ user.currentCurrency?.currency }}</div>
                </div>
                <div class="text-14 mt-20 md:text-10 sm:mt-20">{{ 't.my-winnings' | translate }}</div>
              </div>
              <div class="result-card medium py-20 px-40 flex items-center sm:mt-20">
                <div class="flex items-center w-100">
                  <img class="mr-40" src="/assets/img/user-results/page/won.png" alt="">
                  <div>
                    <div class="text-focus text-24 font-weight-800 md:text-16 sm:mt-20">{{ results.userWinCount() || 0 }} {{ 't.times' | translate }}</div>
                    <div class="text-14 mt-10 md:text-10 text-center sm:mt-20">{{ 't.you-have-won' | translate }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-2 sm:grid-cols-1 gap-20 mb-40 sm:mb-20 sm:order-3">
              @if(loyalty.loyaltyLevels$ | async) {
                <div class="result-card big-height flex flex-col items-center px-28 py-40 sm:px-0 sm:py-14 sm:py-28">
                  <div class="px-20">
                    <app-progress-bar
                      [min]="0"
                      [max]="loyalty.currentLoyaltyLevel?.Bonuses?.length"
                      [value]="loyalty.currentLoyaltyLevel?.choosenBonus?.index"
                    >
                    </app-progress-bar>
                    <div class="flex flex-row justify-between sm:mt-4 w-100">
                      <div class="w-1/3 sm:w-50 text-left">
                        <div class="text-focus text-22 sm:text-16 font-weight-700 mb-12 sm:mb-6">{{ loyalty.currentLoyaltyLevel?.choosenBonus?.index }}</div>
                        <div class="text-14">{{ 't.how-loyalty-bonuses-received' | translate }}</div>
                      </div>
                      <div class="w-1/3 sm:w-50 text-right">
                        <div class="text-focus text-22 sm:text-16 font-weight-700 mb-12 sm:mb-6">{{ loyalty.currentLoyaltyLevel?.Bonuses?.length }}</div>
                        <div class="text-14">{{ 't.how-loyalty-bonuses-left-receive' | translate }}</div>
                      </div>
                    </div>
                  </div>


                  <div *ngIf="loyalty.currentLoyaltyLevel?.choosenBonus?.bonus" class="bonuses__active-bonus">
                    <img *ngIf="!aeService.isAr && loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.bigImg" [src]="loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.bigImg" alt="Bonus image">
                    <img *ngIf="aeService.isAr && loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.games[0]?.imgSrc" [src]="loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.games[0]?.imgSrc" alt="Bonus image">
                    <div class="bonuses__active-bonus_text">
                      <div class="free-spins text-28" [innerHTML]="(loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.prize || loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.text) | safe: 'html'"
                           [ngClass]="{active: loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.active || loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.isPreviousActivated}"></div>
                      @if (loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.games?.length) {
                        <span *ngIf="loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.games as games">
                    {{ 't.on' | translate}}
                          <span (click)="loyalty.openGame(game)" class="link " *ngFor="let game of games; let last = last"
                                [ngClass]="{'text-gradient': aeService.isAr}"
                          >{{ game?.name }}{{ last ? '' : ', ' }}</span>
                  </span>
                      }
                    </div>
                  </div>

                  @if (
                    !loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.active &&
                    !loyalty.currentLoyaltyLevel?.taken && !loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.taken &&
                    !loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.isPreviousActivated &&
                    !loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.expired
                    ) {
                  }
                  <div class="bonuses__action_locked mt-40 sm:mt-20">
                    <i class="icon-lock"></i>
                    <span (click)="loyalty.onLockedTextClick($event, loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.game)" [innerHTML]="loyalty.currentLoyaltyLevel?.choosenBonus?.bonus?.unlockMessage | safe: 'html'"></span>
                  </div>
                </div>
              }

              <div class="result-card special text-black flex flex-col items-center py-40">
                @if (results.userBiggestWinGame()) {
                  <div class="text-24 sm:text-16 w-50 mt-20 uppercase text-center font-weight-800 mb-20">
                    {{ 't.most-successful-game' | translate }}
                  </div>
                  <img width="200" [src]="results.userBiggestWinGame()?.image" alt="">
                  <div class="text-20 mt-20 pt-10 font-weight-600">{{ results.userBiggestWinGame()?.title }}</div>
                  <div class="text-14 mt-20 font-weight-600 uppercase">{{ results.userBiggestWinGame()?.provider === 'softswiss' ? '' : results.userBiggestWinGame()?.provider }}</div>
                } @else {
                  <div class="text-24 sm:text-16 w-50 mt-20 sm:mt-0 uppercase text-center font-weight-800">
                    {{ 't.try-luckiest-game' | translate }}
                  </div>
                  <img class="result-card__luckiest-img sm:my-20" src="/assets/img/user-results/page/luckiest-game.png" alt="">
                  <button class="btn big btn--filled-primary" routerLink="/games">{{ 't.games' | translate }}</button>
                }
              </div>

            </div>
            <div class="grid-wins grid-wins--2-cols mb-40 sm:mb-20 sm:order-2">
              <div class="result-card py-20 px-40 sm:px-20 flex items-center" [ngClass]="{medium: !isMobile()}">
                <div class="flex items-center sm:flex-col w-100">
                  <img class="mr-40 sm:mr-0" src="/assets/img/user-results/page/daily-win.png" alt="">
                  <div>
                    <div class="text-focus text-24 font-weight-800 md:text-16 sm:text-center sm:mt-20">{{ results.userMaxDailyWin() || 0  }} {{ user.currentCurrency?.currency }}</div>
                    <div class="text-14 mt-10 md:text-10 text-center sm:mt-20">{{ 't.highest-daily-winnings' | translate }}</div>
                  </div>
                </div>
              </div>

              <div class="result-card py-20 px-40 sm:px-20 flex items-center" [ngClass]="{medium: !isMobile()}">
                <div class="flex items-center sm:flex-col w-100">
                  <img class="mr-40 sm:mr-0" src="/assets/img/user-results/box.png" alt="">
                  <div>
                    <div class="text-focus text-24 font-weight-800 md:text-16 sm:text-center sm:mt-20">{{ results.userFreespinsTotal() || 0  }} FS</div>
                    <div class="text-14 mt-10 md:text-10 text-center sm:mt-20">{{ 't.how-bonuses-received' | translate }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="flex justify-center">
            <button class="btn big btn--filled-primary" [routerLink]="results.userBiggestWinGame()?.slug ? ('/play/' + results.userBiggestWinGame()?.slug) : '/games'">{{ 'btn.play' | translate }}</button>
          </div>
        </div>
        <div class="bottom-container">
          <div class="container container--mobile flex flex-col flex-center overflow-hidden">
            <div class="my-80 sm:my-60 text-36 sm:text-20 sm:w-50 sm:text-center font-weight-700 text-center uppercase">
              {{ 't.gaming-activity' | translate }}
            </div>
            @if(results.userTopMultiplierGames()?.length) {
              @if (isMobile() && results.userTopMultiplierGames()?.length > 1) {
                <app-slider class="w-100" #gamingActivitySlider [config]="sliderConfig" [slideList]="results.userTopMultiplierGames()">
                  @for (game of results.userTopMultiplierGames(); track $index) {
                    @if (game) {
                      <div class="result-card gaming px-60 pt-40 pb-90 sm:pb-70 text-center flex flex-col items-center w-100 border-box">
                        <div class="flex items-center justify-center">
                          <img class="activity-image mt--90" [src]="'/assets/img/user-results/numbers/' + ($index + 1) + '.png'" alt="">
                        </div>
                        <div class="text-18 font-weight-500 uppercase mt-20 md:text-14">
                          {{ 't.your-maximum-multiplier' | translate }}
                        </div>
                        <div class="text-64 text-uppercase font-weight-800 text-focus mt-40 sm:mt-20 mb-10 md:text-36">{{ game?.x }}x</div>
                        <div class="w-100 ml--40 sm:ml-0 flex justify-center">
                          <div class="flex lh-2 font-weight-600 justify-center items-center px-20 py-10">
                            <img class="game-img mr-10 rounded-md" [src]="game?.image" alt="">
                            <div class="text-left">
                              <div class="text-focus mb-8 text-12 nowrap">{{ game?.title }}</div>
                              <div class="mb-8 text-12 text-left uppercase">{{ game?.provider === 'softswiss' ? '' : game?.provider }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    } @else {
                      <div class="result-card gaming px-60 pt-40 pb-90 sm:pb-1000 text-center flex flex-col items-center w-100 border-box">
                        <div class="flex items-center justify-center">
                          <img class="activity-image mt--90" [src]="'/assets/img/user-results/numbers/' + ($index + 1) + '.png'" alt="">
                        </div>
                        <div class="text-18 font-weight-500 uppercase mt-20 md:text-14">
                          {{ 't.your-maximum-multiplier' | translate }}
                        </div>
                        <div class="text-29 text-uppercase font-weight-800 mt-40 sm:mt-40 mb-40 md:text-20">{{ 't.your-big-wins-await' | translate }}</div>
                      </div>
                    }
                  }
                </app-slider>
              } @else {
                <div class="grid gap-20 grid-cols-activity md:grid-cols-2 sm:grid-cols-1 w-100">
                  @for (game of results.userTopMultiplierGames(); track $index) {
                    @if (game) {
                      <div class="result-card gaming pt-40 pb-90 text-center flex flex-col items-center border-box">
                        <div class="flex items-center justify-center">
                          <img class="activity-image mt--90" [src]="'/assets/img/user-results/numbers/' + ($index + 1) + '.png'" alt="">
                        </div>
                        <div class="text-18 font-weight-500 uppercase mt-20 md:text-14 w-75">
                          {{ 't.your-maximum-multiplier' | translate }}
                        </div>
                        <div class="text-64 text-uppercase font-weight-800 text-focus mt-40 mb-10 md:text-36">{{ game?.x }}x</div>
                        <div class="w-100 flex justify-center">
                          <div class="flex lh-2 font-weight-600 justify-center items-center w-50 px-20 py-10">
                            <img class="game-img mr-10 rounded-md" [src]="game?.image" alt="">
                            <div class="text-left">
                              <div class="text-focus mb-8 text-12 nowrap">{{ game?.title }}</div>
                              <div class="mb-8 text-12 text-left uppercase">{{ game?.provider === 'softswiss' ? '' : game?.provider }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    } @else {
                      <div class="result-card gaming pt-40 pb-90 text-center flex flex-col items-center border-box">
                        <div class="flex items-center justify-center">
                          <img class="activity-image mt--90" [src]="'/assets/img/user-results/numbers/' + ($index + 1) + '.png'" alt="">
                        </div>
                        <div class="text-18 font-weight-500 uppercase mt-20 md:text-14 w-75">
                          {{ 't.your-maximum-multiplier' | translate }}
                        </div>
                        <div class="result-card__gaming-text text-30 font-weight-600 mt-50 sm:mt-20 mb-10 md:text-20">{{ 't.your-big-wins-await' | translate }}</div>
                      </div>
                    }
                  }
                </div>
              }
            }
          </div>

          <div class="container">
            <div class="grid-wins my-60 sm:mt-50 sm:mb-20">
              <div class="result-card p-20 flex flex-col items-center justify-between">
                <div class="flex flex-col items-center">
                  <img src="/assets/img/user-results/chaplet.png" alt="">
                  <div class="text-focus text-24 font-weight-800 md:text-16 sm:mt-20">
                    {{ results.userTotalBetsCount() }}
                  </div>
                </div>
                <div class="text-14 mt-20 md:text-10">{{ 't.number-bets' | translate }}</div>
              </div>
              <div class="result-card p-20 flex flex-col items-center justify-between">
                <div class="flex flex-col items-center">
                  <img src="/assets/img/user-results/asterisk.png" alt="">
                  <div class="text-focus text-24 font-weight-800 md:text-16 sm:mt-20">{{ results.userMaxWinStreak() || 0 }}</div>
                </div>
                <div class="text-14 mt-20 md:text-10">{{ 't.max-winning-streak' | translate }}</div>
              </div>
              <div class="result-card medium py-20 px-32 sm:px-0 sm:mt-20 flex items-center">
                <div class="px-20 w-100">
                  <app-progress-bar
                    [min]="0"
                    [max]="results.userFreespinsTotal()"
                    [value]="results.userFreespinsUsed()"
                  >
                  </app-progress-bar>
                  <div class="flex flex-row justify-between w-100">
                    <div class="w-1/3 sm:w-50 text-left">
                      <div class="text-focus text-22 sm:text-16 font-weight-700 mb-12 sm:mb-6 sm:mt-20">{{ results.userFreespinsUsed() }}</div>
                      <div class="text-14 sm:text-12 sm:mt-20">{{ 't.how-many-fs-used' | translate }}</div>
                    </div>
                    <div class="w-1/3 sm:w-50 text-right">
                      <div class="text-focus text-22 sm:text-16 font-weight-700 mb-12 sm:mb-6 sm:mt-20">{{ results.userFreespinsTotal() }}</div>
                      <div class="text-14 sm:text-12 sm:mt-20">{{ 't.how-many-fs-receive' | translate }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="container">
          <div class="result-card flex items-center py-36 px-50 mb-60" [ngClass]="{medium: isMobile(), big: !isMobile()}">
            <img src="/assets/img/user-results/cup.png" alt="">
            <div class="flex flex-col ml-40 sm:w-50">
              <div class="text-focus text-white text-36 font-weight-800 md:text-16">{{ results.userWinDiffPercentLastVsCurrent() ? (
                !results.isNegativeLastVsCurrent ? ('t.last-month-more-than-current' | translate: {value: results.userWinDiffPercentLastVsCurrent()}) :
                  ('t.current-month-more-than-last' | translate: {value: results.userWinDiffPercentLastVsCurrent()})
              ) : 't.start-win-now' | translate
                }}</div>
              <div class="text-14 mt-20 md:text-10">{{ 't.win-rate' | translate }}</div>
            </div>
          </div>

            <div class="grid-wins grid-wins--2-cols mb-40">
              <div class="result-card py-20 px-40 sm:px-20 flex items-center" [ngClass]="{medium: !isMobile()}">
                <div class="flex items-center sm:flex-col w-100">
                  <img class="mr-40 sm:mr-0" src="/assets/img/user-results/day.png" alt="">
                  <div>
                    <div class="text-focus text-24 font-weight-800 md:text-16 sm:text-center sm:mt-20">{{ (results.userBiggestWinDay() ? ('t.' +  results.userBiggestWinDay()) : 't.today') | translate }}</div>
                    <div class="text-14 mt-10 sm:mt-20 md:text-10 sm:text-center">{{ 't.your-lucky-days' | translate }}</div>
                  </div>
                </div>
              </div>
              <div class="result-card py-20 px-40 sm:px-20 flex items-center" [ngClass]="{medium: !isMobile()}">
                <div class="flex items-center sm:flex-col w-100">
                  <img class="mr-40 sm:mr-0" src="/assets/img/user-results/seven.png" alt="">
                  <div>
                    <div class="text-focus text-24 font-weight-800 md:text-16 sm:text-center sm:mt-20">{{ results.userSlotCount() }}</div>
                    <div class="text-14 mt-10 sm:mt-20 md:text-10 sm:text-center">{{ 't.how-many-slots-played' | translate }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex justify-center">
              <button routerLink="/games" class="btn big btn--filled-primary">{{ 'btn.play' | translate }}</button>
            </div>
          </div>
        </div>
      </ng-template>
  </div>
}


<app-bottom-navigation></app-bottom-navigation>
<app-footer></app-footer>
